var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGuideIco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 81,
    viewBox: "0 0 82 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.8044 8.46029C71.8044 9.24771 71.2173 9.82537 70.5653 9.82537C69.9133 9.82537 69.3262 9.24771 69.3262 8.46029C69.3262 7.67288 69.9133 7.09521 70.5653 7.09521C71.2173 7.09521 71.8044 7.67288 71.8044 8.46029Z",
    fill: "#EEEBE7",
    stroke: "#EEEBE7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5876 8.46029C66.5876 9.24771 66.0005 9.82537 65.3485 9.82537C64.6965 9.82537 64.1094 9.24771 64.1094 8.46029C64.1094 7.67288 64.6965 7.09521 65.3485 7.09521C66.0005 7.09521 66.5876 7.67288 66.5876 8.46029Z",
    fill: "#EEEBE7",
    stroke: "#EEEBE7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 14.0556V79.3333H81V1H1V8.46032H61.8696",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0212 8.46029C77.0212 9.24771 76.4341 9.82537 75.7821 9.82537C75.1301 9.82537 74.543 9.24771 74.543 8.46029C74.543 7.67288 75.1301 7.09521 75.7821 7.09521C76.4341 7.09521 77.0212 7.67288 77.0212 8.46029Z",
    fill: "#EEEBE7",
    stroke: "#EEEBE7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1309 19.6509H68.8265",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1738 27.1113H68.826",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3904 42.0316C20.3114 42.0316 21.8686 40.3616 21.8686 38.3014C21.8686 36.2413 20.3114 34.5713 18.3904 34.5713C16.4694 34.5713 14.9121 36.2413 14.9121 38.3014C14.9121 40.3616 16.4694 42.0316 18.3904 42.0316Z",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8251 38.3013H27.0859",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1738 19.6509H16.6521",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3904 55.0873C20.3114 55.0873 21.8686 53.4172 21.8686 51.3571C21.8686 49.297 20.3114 47.627 18.3904 47.627C16.4694 47.627 14.9121 49.297 14.9121 51.3571C14.9121 53.4172 16.4694 55.0873 18.3904 55.0873Z",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8251 51.3569H27.0859",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3904 68.1429C20.3114 68.1429 21.8686 66.4729 21.8686 64.4128C21.8686 62.3527 20.3114 60.6826 18.3904 60.6826C16.4694 60.6826 14.9121 62.3527 14.9121 64.4128C14.9121 66.4729 16.4694 68.1429 18.3904 68.1429Z",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8251 64.4126H27.0859",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideIco);
export default __webpack_public_path__ + "static/media/guide-ico.00cd885c6e7210e0ce5081e8c51c63da.svg";
export { ForwardRef as ReactComponent };